import clsx from 'clsx';
import Icon from '../../Icon';
import { IconSpecificProps } from '../../Icon.types';
import styles from './IconPlusToMinus.module.scss';

const IconPlusToMinus = ({ className, titleAccess, isOpen }: IconSpecificProps) => (
  <Icon
    className={clsx(styles.icon, className, isOpen && styles.active)}
    titleAccess={titleAccess}
    viewBox="0 0 25 25"
    fill="none">
    <path
      d="M4.75 12H20.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 4L12.75 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconPlusToMinus;
